import { gql } from "@apollo/client";
import { Condition as condition } from "../fragments";

const CREATE_CONDITION = props => gql`
  mutation CreateCondition($input: CreateConditionInput!) {
    createCondition(input: $input) {
      success
      error
      condition {
        ${condition(props)}
      }
    }
  }
`;

const DELETE_CONDITION = props => gql`
  mutation DeleteCondition($input: DeleteConditionInput!) {
    deleteCondition(input: $input) {
      success
      error
    }
  }
`;

const UPDATE_CONDITION = props => gql`
  mutation UpdateCondition($input: UpdateConditionInput!) {
    updateCondition(input: $input) {
      success
      error
      condition {
        ${condition(props)}
      }
    }
  }
`;

export { CREATE_CONDITION, DELETE_CONDITION, UPDATE_CONDITION };
